exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".GalleryPage img {\n  max-width: 100%;\n  max-height: 120px;\n}\n\n.GalleryPage .gallery-item {\n  border-bottom: 1px solid black;\n  line-height: 120px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.GalleryPage .gallery-item > div {\n  -webkit-align-self: center;\n      -ms-flex-item-align: center;\n          align-self: center;\n  max-height: 120px;\n}\n\n.GalleryPage .gallery-item > div > * {\n  line-height: 1.42857143;\n}\n\n.GalleryPage {\n  margin-top: 5px;\n}\n\n.GalleryPage .no-padding {\n  padding: 0px;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/components/GalleryPage/GalleryPage.css
 ** module id = 425
 ** module chunks = 0
 **/